export default "__VITE_PUBLIC_ASSET__b502a7b4__"